import i18n from '@/lang';
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
export * from './menuMapping';
export * from './order';
export * from './operation';

// 工单状态映射表
export var roleLabelMapping = {
  1: i18n.tc("43"),
  2: i18n.tc("44"),
  3: i18n.tc("45"),
  4: i18n.tc("46"),
  5: i18n.tc("47"),
  6: i18n.tc("48"),
  7: i18n.tc("49"),
  8: i18n.tc("50"),
  9: i18n.tc("51"),
  10: i18n.tc("52")
};
export var eventFilterList = [{
  value: 0,
  name: i18n.tc("53"),
  color: '#fa5d3a',
  mapState: [{
    dispatch_state: 0,
    process_state: 0,
    upgrade_state: 0,
    pause_state: 0,
    close_state: 0,
    is_upgrade: 0
  }],
  mapStateIndex: 0
}, {
  value: 1,
  name: i18n.tc("54"),
  color: '#0075ed',
  mapState: [{
    dispatch_state: 1,
    process_state: 0,
    upgrade_state: 0,
    pause_state: 0,
    close_state: 0,
    is_upgrade: 0
  }, {
    dispatch_state: 1,
    process_state: 0,
    upgrade_state: 0,
    pause_state: 0,
    close_state: 0,
    is_coordination: 1,
    is_upgrade: 0
  }, {
    dispatch_state: 1,
    process_state: 0,
    upgrade_state: 0,
    pause_state: 0,
    close_state: 0,
    is_upgrade: 1
  }],
  mapStateIndex: 0
}, {
  value: 2,
  name: i18n.tc("55"),
  color: '#e49100',
  mapState: [{
    dispatch_state: 1,
    process_state: 1,
    upgrade_state: 0,
    pause_state: 0,
    close_state: 0,
    is_upgrade: 0
  }, {
    dispatch_state: 1,
    process_state: 1,
    upgrade_state: 0,
    pause_state: 0,
    close_state: 0,
    is_coordination: 1,
    is_upgrade: 0
  }, {
    dispatch_state: 1,
    process_state: 1,
    upgrade_state: 0,
    pause_state: 0,
    close_state: 0,
    is_upgrade: 1
  }],
  mapStateIndex: 0
}, {
  value: 3,
  name: i18n.tc("56"),
  color: '#0abd12',
  mapState: [{
    dispatch_state: 1,
    process_state: 2,
    upgrade_state: [0, 1],
    pause_state: 0,
    close_state: 0
  }],
  mapStateIndex: 0
}, {
  value: 4,
  name: i18n.tc("57"),
  color: '#808080',
  mapState: [{
    process_state: [0, 1],
    upgrade_state: [0, 1],
    pause_state: 0,
    close_state: 1
  }],
  mapStateIndex: 0
}, {
  value: 5,
  name: i18n.tc("58"),
  color: '#e82a2a',
  mapState: [{
    process_state: [0, 1],
    pause_state: 1,
    close_state: 0
  }],
  mapStateIndex: 0
}, {
  value: 6,
  name: i18n.tc("59"),
  color: '#11d8fb',
  mapState: [{
    dispatch_state: 1,
    process_state: [0, 1],
    upgrade_state: 1,
    pause_state: 0,
    close_state: 0,
    is_upgrade: 0
  }, {
    dispatch_state: 1,
    process_state: [0, 1],
    upgrade_state: 1,
    pause_state: 0,
    close_state: 0,
    is_coordination: 1,
    is_upgrade: 0
  }, {
    dispatch_state: 1,
    process_state: [0, 1],
    upgrade_state: 1,
    pause_state: 0,
    close_state: 0,
    is_upgrade: 1
  }],
  mapStateIndex: 0
}];
export var getEventFilterState = function getEventFilterState(event) {
  function _objToMap(obj, map) {
    var res = false;
    var keys = Object.keys(map);
    res = keys.every(function (key) {
      var value = map[key];
      if (Array.isArray(value)) {
        return value.includes(obj[key]);
      } else {
        return value === obj[key];
      }
    });
    return res;
  }
  for (var index = 0; index < eventFilterList.length; index++) {
    var nonce = eventFilterList[index];
    var mapState = nonce.mapState;
    var res = mapState.find(function (v) {
      return _objToMap(event, v);
    });
    if (res) {
      nonce.mapStateIndex = mapState.findIndex(function (v) {
        return _objToMap(event, v);
      });
      return nonce;
    }
  }
  var defaultValue = {
    value: -1,
    name: i18n.tc("60"),
    color: '#ff4d4f'
  };
  return defaultValue;
};